import { baseApiServer } from './environment';

export const apiList = {
  login: `${baseApiServer('USERS')}/login`,
  verify: `${baseApiServer('USERS')}/verify`,
  isAuth: `${baseApiServer('USERS')}is-auth`,
  users: `${baseApiServer('USERS')}`,

  clients: `${baseApiServer('CLIENTS')}`
};
